var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYandex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3237_23488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.6875C5.56486 1.6875 2.375 4.87736 2.375 8.8125C2.375 10.7794 3.17193 12.5603 4.46084 13.8495C5.75011 15.1395 8.7875 17.0063 8.96563 18.9656C8.99233 19.2594 9.20503 19.5 9.5 19.5C9.79497 19.5 10.0077 19.2594 10.0344 18.9656C10.2125 17.0063 13.2499 15.1395 14.5392 13.8495C15.8281 12.5603 16.625 10.7794 16.625 8.8125C16.625 4.87736 13.4351 1.6875 9.5 1.6875Z",
    fill: "#FF4433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5001 11.3059C10.8774 11.3059 11.9938 10.1894 11.9938 8.81211C11.9938 7.43485 10.8774 6.31836 9.5001 6.31836C8.12285 6.31836 7.00635 7.43485 7.00635 8.81211C7.00635 10.1894 8.12285 11.3059 9.5001 11.3059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3237_23488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.881651a0cbdf4f87ae35301d1faa0b4e.svg";
export { ForwardRef as ReactComponent };